import React, { createContext, useCallback, useContext, useState } from 'react';

const AlertsUIContext = createContext(null);

export function AlertsUIProvider({ children }) {
    const [clearedIds, setClearedIds] = useState(new Set());

    const clearAlert = useCallback((id) => {
        setClearedIds((prev) => new Set([...prev, id]));
    }, []);

    const clearAllAlerts = useCallback((ids) => {
        setClearedIds((prev) => new Set([...prev, ...ids]));
    }, []);

    return (
        <AlertsUIContext.Provider value={{ clearedIds, clearAlert, clearAllAlerts }}>
            {children}
        </AlertsUIContext.Provider>
    );
}

export function useAlertsUI() {
    const ctx = useContext(AlertsUIContext);
    if (!ctx) throw new Error('useAlertsUI must be used inside AlertsUIProvider');
    return ctx;
}
